import { matchPath } from 'react-router';
import { compile } from 'path-to-regexp';
import { NikeRoute, RouteParams } from './types';

export function getPathnameFromRoute(route: NikeRoute, params: RouteParams) {
    return decodeURIComponent(compile(route.path)(params));
}

export function matchesAnyRoute(path: string, routes: NikeRoute[]) {
    return routes.find(route =>
        matchPath(path, {
            path: route.path
        })
    );
}

export const httpUrlRegex = new RegExp('^http');
